// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3qf1u","title":"AfterFrontImage_title__1cjmc"};